export default __webpack_public_path__ + "static/media/project_thumbnail_cdf.4807c0d9.png";